//TREND ANGGOTA
export const GET_TREND_ANGGOTA = "GET_TREND_ANGGOTA";
export const GET_TREND_ANGGOTA_SUCCESS = "GET_TREND_ANGGOTA_SUCCESS";
export const GET_TREND_ANGGOTA_FAIL = "GET_TREND_ANGGOTA_FAIL";

export const GET_ANGGOTA_OVERVIEW = "GET_ANGGOTA_OVERVIEW";
export const GET_ANGGOTA_OVERVIEW_SUCCESS = "GET_ANGGOTA_OVERVIEW_SUCCESS";
export const GET_ANGGOTA_OVERVIEW_FAIL = "GET_ANGGOTA_OVERVIEW_FAIL";

export const GET_ANGGOTA_PROVINSI = "GET_ANGGOTA_PROVINSI";
export const GET_ANGGOTA_PROVINSI_SUCCESS = "GET_ANGGOTA_PROVINSI_SUCCESS";
export const GET_ANGGOTA_PROVINSI_FAIL = "GET_ANGGOTA_PROVINSI_FAIL";

export const GET_ANGGOTA_KABKOT = "GET_ANGGOTA_KABKOT";
export const GET_ANGGOTA_KABKOT_SUCCESS = "GET_ANGGOTA_KABKOT_SUCCESS";
export const GET_ANGGOTA_KABKOT_FAIL = "GET_ANGGOTA_KABKOT_FAIL";

export const GET_ANGGOTA_KECAMATAN = "GET_ANGGOTA_KECAMATAN";
export const GET_ANGGOTA_KECAMATAN_SUCCESS = "GET_ANGGOTA_KECAMATAN_SUCCESS";
export const GET_ANGGOTA_KECAMATAN_FAIL = "GET_ANGGOTA_KECAMATAN_FAIL";